import { render } from "./AdminSearcher.vue?vue&type=template&id=3751ddea&scoped=true&ts=true"
import script from "./AdminSearcher.vue?vue&type=script&lang=ts"
export * from "./AdminSearcher.vue?vue&type=script&lang=ts"

import "./AdminSearcher.vue?vue&type=style&index=0&id=3751ddea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3751ddea"]])

export default __exports__